import { HookCheckboxField } from "@litbase/alexandria";
import styled from "styled-components";

export const StyledHookCheckboxField = styled(HookCheckboxField)`
  color: ${({ theme }) => theme.blue};
`;
